<div class="delete-user-title" style="background-color: #ededed;">
    <span class="order-text">{{'common.mycompany_user_delete_account'|cxTranslate}}</span>

    <button class="dialog-close-btn" aria-label="close dialog" mat-dialog-close>
        <img src="/icons/close-light-grey.svg" alt=""  width="25" />
    </button>
</div>

<mat-dialog-content class="vor-order-dialog">
    <div class="addressItem">
        <div class="address">
            {{'common.mycompany_user_delete_confMessage'|cxTranslate}}<br>
         <span class="blue-text following-user">{{_data}}</span><br><br>
         {{'common.mycompany_user_delete_note'|cxTranslate}}</div>
 </div>

</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-center">
    <div class="row">
        <div class="col-xs-12 col-sm-12">
            <button class="btn btn-default btn-block yellow-btn" (click)="delUser()">
                {{'common.text_address_delete'|cxTranslate}}<img src="/icons/link-dark-grey.svg" alt="Link Icon">
            </button>
        </div>
        <div class="col-xs-12 col-sm-12">
            <a class="btn  btn-block blue-btn closeColorBox" mat-dialog-close>
                {{'common.text_button_cancel'|cxTranslate}}</a>
        </div>
    </div>
</mat-dialog-actions>
